import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  setSelectedIdWithDrawer,
  navigatorIsFullscreen,
} from 'actions/navigator'

import { addXmc } from 'actions/truck'

import * as truckSelectors from 'selectors/truck.js'
import strings from 'utils/strings'
import { ECUS_ADD_XMC_SUCCESS_NOTIFY } from 'utils/notifications'
import AddXMC from './AddXMC'
import { deleteSystemNotification } from 'actions/application'

const NotificationMessage = ({ newXmcs }) => {
  const msg = `${newXmcs
    .slice(0, newXmcs.length > 1 ? newXmcs.length - 1 : 1)
    .map((item) => item.name)
    .join(', ')}${strings.add_xmc_success_message(
    newXmcs.length > 1 ? newXmcs[newXmcs.length - 1].name : null
  )}`
  return <span>{msg}</span>
}

const mapStateToProps = (state, { serialNumber }) => {
  const vehicle = truckSelectors.getTruckDataBySerialNumber(serialNumber, state)

  return {
    vehicle: vehicle || {},
  }
}

const mapDispatchToProps = (dispatch, { serialNumber }) => {
  return {
    closeDrawer: () => {
      dispatch(setSelectedIdWithDrawer(false))
      dispatch(navigatorIsFullscreen(false))
    },
    addXmc: (payload) => {
      dispatch(deleteSystemNotification({notificationId: ECUS_ADD_XMC_SUCCESS_NOTIFY}))
      dispatch(addXmc(payload))
    },
  }
}

const AddXMCContainer = connect(mapStateToProps, mapDispatchToProps)(AddXMC)

NotificationMessage.propTypes = {
  newXmcs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default AddXMCContainer
